<template>
  <TermsPage type="cities" name="Cities" :slug="$route.params.slug" />
</template>
